export default "__VITE_ASSET__39b822ba__"